export class GoogleMapStatus {
    static NOT_FOUND = 'NOT_FOUND';
}

Object.freeze(GoogleMapStatus);